import React from "react";
import {
  Box,
  Flex,
  Text,
  Stack,
  Link,
  Divider,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const bgColor = useColorModeValue("rgba(243, 244, 246, 0.72)", "rgba(15, 23, 42, 0.55)");
  const topLine = useColorModeValue("rgba(45, 212, 191, 0.2)", "rgba(94, 234, 212, 0.12)");
  const insetShine = useColorModeValue(
    "inset 0 1px 0 rgba(255,255,255,0.45)",
    "inset 0 1px 0 rgba(255,255,255,0.06)"
  );
  const textColor = useColorModeValue("gray.600", "gray.300");
  const linkColor = useColorModeValue("blue.600", "blue.300");
  const linkHoverColor = useColorModeValue("blue.800", "blue.500");

  const linkProps = {
    fontSize: "sm",
    color: linkColor,
    _hover: { color: linkHoverColor, textDecoration: "underline" },
  };

  return (
    <Box
      bg={bgColor}
      color={textColor}
      py={10}
      mt="auto"
      borderTopWidth="1px"
      borderTopColor={topLine}
      backdropFilter="blur(14px)"
      WebkitBackdropFilter="blur(14px)"
      boxShadow={insetShine}
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        textAlign="center"
        maxW="960px"
        mx="auto"
        px={4}
      >
        <Stack spacing={5} mb={5}>
          <Flex justify="center" flexWrap="wrap" gap={{ base: 4, md: 6 }}>
            <Link href="/blog" {...linkProps}>
              Blog
            </Link>
            <Link href="/templates" {...linkProps}>
              Templates
            </Link>
            <Link href="/success-stories" {...linkProps}>
              Success stories
            </Link>
            <Link href="/pricing" {...linkProps}>
              Pricing
            </Link>
            <Link href="/faqs" {...linkProps}>
              FAQs
            </Link>
            <Link href="/contact-us" {...linkProps}>
              Contact
            </Link>
            <Link href="/privacy-policy" {...linkProps}>
              Privacy
            </Link>
            <Link href="/terms-and-conditions" {...linkProps}>
              Terms
            </Link>
          </Flex>
        </Stack>

        <Divider />

        <Stack mt={6} spacing={4}>
          <Link
            href="https://www.linkedin.com/company/manage360-me"
            isExternal
            aria-label="Manage360 on LinkedIn"
          >
            <Icon as={FaLinkedin} boxSize={6} color={linkColor} _hover={{ color: linkHoverColor }} />
          </Link>
          <Text fontSize="sm">
            &copy; {new Date().getFullYear()} Our Software Solutions Pvt. Ltd.
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
};

export default Footer;
